var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 62 62"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 31,
  r: 30,
  fill: "#EAE5E1",
  stroke: "#EAE5E1",
  strokeWidth: 0.75
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M31 1C14.433 1 1 14.431 1 31c0 16.569 13.432 30 30 30 16.57 0 30-13.431 30-30C61 14.431 47.57 1 31 1Zm0 8.97c5.482 0 9.924 4.444 9.924 9.924 0 5.48-4.442 9.923-9.924 9.923-5.48 0-9.921-4.442-9.921-9.923 0-5.48 4.442-9.923 9.921-9.923Zm-14.344 37.9a22.016 22.016 0 0 0 14.337 5.286 22.009 22.009 0 0 0 14.339-5.288 4.218 4.218 0 0 0 1.482-3.213c0-5.557-4.48-10.005-10.04-10.005H25.228c-5.558 0-10.056 4.448-10.056 10.005 0 1.235.543 2.412 1.484 3.214Z",
  clipRule: "evenodd"
})));
export default SvgUser;